<template>
  <v-row justify="center">
    <v-dialog v-model='adminmodal' max-width="600">
      <v-card>
        <v-toolbar height="73" color="white" class="headlinestyle">
          <v-btn icon @click="cancel()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title><strong>{{title}}</strong></v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-layout row wrap justify-center hidden-sm-and-down >
            <br />
            <v-flex xs8 sm10 md10 lg10>
              <v-layout row wrap align-center pt-4>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm12 md12 lg12 px-3 v-if="id">
                    <v-text-field v-model="id" label='USER ID' required readonly filled></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 px-3>
                    <v-text-field v-model="username" label='Username' required :rules="[v => !!v || 'กรุณากรอก Username']" style='display:inline;' color="pink lighten-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 px-3>
                    <v-text-field v-model="password" label='Password' required :rules="[v => !!v || 'กรุณากรอก Password']" style='display:inline;' color="pink lighten-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 px-3 pt-2>
                    <v-text-field v-model="name" label='ชื่อ-สกุล' required :rules="[v => !!v || 'กรุณากรอก ชื่อ-สกุล']" style='display:inline;' color="pink lighten-2"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6 lg6 px-3 pt-2>
                    <v-select
                      :items="levelitems"
                      label="ระดับเจ้าหน้าที่"
                      v-model="level"
                      dense
                      color="pink lighten-2"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-center hidden-md-and-up >
            <v-flex xs10 sm10 md10 lg10>
                <v-layout justify-center v-if="id">
                  <v-text-field v-model="id" label='USER ID' required readonly filled></v-text-field>
                </v-layout>
                <v-layout justify-center>
                  <v-text-field v-model="username" label='Username' required :rules="[v => !!v || 'กรุณากรอก Username']" style='display:inline;' color="pink lighten-2"></v-text-field>
                </v-layout>
                <v-layout justify-center>
                  <v-text-field v-model="password" label='Password' required :rules="[v => !!v || 'กรุณากรอก Password']" style='display:inline;' color="pink lighten-2"></v-text-field>
                </v-layout>
                <v-layout justify-center>
                  <v-text-field v-model="name" label='ชื่อ-สกุล' required :rules="[v => !!v || 'กรุณากรอก ชื่อ-สกุล']" style='display:inline;' color="pink lighten-2"></v-text-field>
                </v-layout>
                <br />
                <v-layout justify-start>
                  <v-flex xs12 sm12 md4 lg4>
                    <v-select
                      :items="levelitems"
                      label="ระดับเจ้าหน้าที่"
                      v-model="level"
                      dense
                      color="pink lighten-2"
                    ></v-select>
                  </v-flex>
                </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn color="pink" style="margin-right: 5px" outlined @click="cancel()">ยกเลิก</v-btn>

          <v-btn color="pink lighten-2" dark @click="save()">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { sync } from 'vuex-pathify'
// import axios from 'axios'
import swal from 'sweetalert'
export default {
  data () {
    return {
      title: 'เพิ่มข้อมูลเจ้าหน้าที่',
      currentdata: '',
      id: '',
      username: '',
      name: '',
      password: '',
      level: 'admin',
      levelitems: ['admin', 'super admin', 'clerk']
    }
  },
  props: {
    // eslint-disable-next-line vue/require-prop-type-constructor
    parentgetdata: ''
  },
  methods: {
    async save () {
      try {
        if (this.username && this.name && this.password) {
          let tempdata = {
            username: this.username,
            name: this.name,
            password: this.password,
            level: this.level,
            status: 'admin'
          }

          let swaltext = ''
          if (this.currentadmindata !== '') {
            await this.axios.put(`${process.env.VUE_APP_API}/user/edit/`, { ...tempdata, userid: this.id }, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            swaltext = 'บันทึกการแก้ไขข้อมูลเจ้าหน้าที่เรียบร้อย'
          } else {
            let { data } = await this.axios.post(`${process.env.VUE_APP_API}/user/create`, tempdata, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            swaltext = 'บันทึกข้อมูลเจ้าหน้าที่ใหม่เรียบร้อย'
            if (data.message === 'Create user successfully.') {
              this.resetdata()
            }
          }

          this.adminmodal = false
          await swal(swaltext, {
            icon: 'success',
            buttons: 'ตกลง'
          })
          this.parentgetdata()
        } else {
          await swal({
            title: `กรุณากรอกข้อมูลเจ้าหน้าที่ให้ครบถ้วน`,
            icon: 'warning',
            buttons: 'ตกลง',
            dangerMode: true
          })
        }
      } catch (error) {
        if (error.response.status === 400) {
          await swal({
            title: `Username นี้มีอยู่แล้วในระบบ`,
            icon: 'warning',
            buttons: 'ตกลง',
            dangerMode: true
          })
        } else {
          await swal({
            title: `ระบบผิดพลาด`,
            text: 'กรุณาลองอีกครั้งในภายหลัง',
            icon: 'warning',
            buttons: 'ตกลง',
            dangerMode: true
          })
        }
      }
    },
    cancel () {
      this.resetdata()
      this.adminmodal = false
    },
    resetdata () {
      this.currentadmindata = ''
      this.username = ''
      this.name = ''
      this.password = ''
    }
  },
  computed: {
    adminmodal: sync('adminmodal'),
    currentadmindata: sync('currentadmindata')
  },
  watch: {
    currentadmindata () {
      if (this.currentadmindata !== '') {
        this.currentdata = JSON.parse(this.currentadmindata)
        this.id = this.currentdata._id
        this.username = this.currentdata.username
        this.password = this.currentdata.password
        this.name = this.currentdata.name
        this.level = this.currentdata.level
        this.title = `แก้ไขข้อมูลเจ้าหน้าที่`
      } else if (this.currentadmindata === '') {
        this.id = ''
        this.username = ''
        this.name = ''
        this.password = ''
        this.level = 'admin'
        this.title = `เพิ่มข้อมูลเจ้าหน้าที่`
      }
    }
  }
}
</script>
<style>
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.inputstyle {
  font-style: normal;
  font-weight: normal;
}
.v-text-field {
    font-family: 'Kanit';
}

.v-btn {
    font-family: 'Kanit';
    font-weight: bold;
}

p {
    font-family: 'Kanit';
}
.v-list-item__title {
  font-family: 'Kanit';
}
</style>
